import AlertModalReducer from "../reducers/AlertModalReducer";
import BaseAction from "./BaseAction";

class AlertModalAction extends BaseAction {
  onClose = () => {};

  open = async (message, title = "Error", onClose = () => {}) => {
    this.onClose = onClose;
    this.dispatch({ open: true, message, title });
  };
}

const action = new AlertModalAction(AlertModalReducer);

export default action;
